const Supplier = () => import('@/pages/supplier/Supplier.vue');
const SupplierInfo = () => import('@/pages/supplier/SupplierInfo.vue');
const AllMusic = () => import('@/pages/allMusic/AllMusic.vue');
const MusicFine = () => import('@/pages/home/Home.vue');
// const MusicFine = () => import('@/pages/musicFine/musicFine.vue');
const Package = () => import('@/pages/package/Package.vue');
const Playlist  = () => import('@/pages/songList/SongList.vue');
const SonglistDetail  = () => import('@/pages/songList/SonglistDetail.vue');
const AIMusic  = () => import('@/pages/ai/AI.vue');
const AIChat  = () => import('@/pages/ai/Chat.vue');
// const SongListPay = () => import('@/pages/songList/SongListPay.vue');

export default [
  {
    path: '/supplier',
    name: 'musicSuplier',
    component: Supplier
  },
  {
    path: '/supplierinfo/:user_id',
    name: 'supplierinfo',
    component: SupplierInfo
  },
  {
    path: '/allSound',
    name: 'allSound',
    component: AllMusic
  },
  {
    path: '/vipMusic',
    name: 'vipMusic',
    component: AllMusic
  },
  {
    path: '/allMusic',
    name: 'allMusic',
    component: AllMusic
  },
  {
    path: '/playlist',
    name: 'playlist',
    component: Playlist
  },
  {
    path: '/playListDetail/:playlist_id',
    name: 'playListDetail',
    component: SonglistDetail
  },
  {
    path: '/musicFine',
    name: 'musicFine',
    component: MusicFine
  },
  {
    path: '/package',
    name: 'package',
    component: Package
  },
  {
    path: '/aitomusic',
    name: 'aitomusic',
    component: AIMusic
  },
  {
    path: '/aichat',
    name: 'aichat',
    component: AIChat
  },
  
  // {
  //   path: '/songlist/pay/:order_id',
  //   name: 'songlistpay',
  //   component: SongListPay
  // },
]